/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const putProjectsProjectidPreferencesUnitsStatus200Schema = z.object({
  id: z.string().describe('Unique identifier').meta({ examples: [1] }),
  type: z.enum(['area', 'density', 'diameter', 'differentialPressure', 'electricalPower', 'energy', 'flow', 'force', 'heatTransfer', 'kinematicViscosity', 'kvCvCoefficient', 'length', 'linearPressureDrop', 'mass', 'roughness', 'specificHeat', 'staticPressure', 'temperature', 'temperatureDifference', 'thermalConductivity', 'thermalPower', 'thickness', 'torque', 'velocity', 'volume', 'waterHardness']).describe('The type of the unit').meta({ examples: ['length'] }),
  value: z.string().describe('The preferred unit of the user for the given type').meta({ examples: ['_U_LENGTH_CM'] }),
})

export const putProjectsProjectidPreferencesUnitsStatus400Schema = z.string()

export const putProjectsProjectidPreferencesUnitsStatus401Schema = z.string()

export const putProjectsProjectidPreferencesUnitsStatus500Schema = z.string()

export const putProjectsProjectidPreferencesUnitsResponseSchema = putProjectsProjectidPreferencesUnitsStatus200Schema

export const putProjectsProjectidPreferencesUnitsErrorSchema = z.union([putProjectsProjectidPreferencesUnitsStatus400Schema, putProjectsProjectidPreferencesUnitsStatus401Schema, putProjectsProjectidPreferencesUnitsStatus500Schema])

export const putProjectsProjectidPreferencesUnitsBodySchema = z.array(z.object({
  type: z.enum(['area', 'density', 'diameter', 'differentialPressure', 'electricalPower', 'energy', 'flow', 'force', 'heatTransfer', 'kinematicViscosity', 'kvCvCoefficient', 'length', 'linearPressureDrop', 'mass', 'roughness', 'specificHeat', 'staticPressure', 'temperature', 'temperatureDifference', 'thermalConductivity', 'thermalPower', 'thickness', 'torque', 'velocity', 'volume', 'waterHardness']).describe('The type of the unit').meta({ examples: ['length'] }),
  value: z.string().describe('The preferred unit of the user for the given type').meta({ examples: ['_U_LENGTH_CM'] }),
})).optional()
